import React from 'react';

/**
 * @typedef {object} StickyHeaderProps
 * @property {React.ReactNode} children
 */

/**
 * @param {StickyHeaderProps} props
 */
const StickyHeader = props => {
  const { children } = props;

  return <section className='sticky-header-wrapper'>{children}</section>;
};

export default StickyHeader;
